import { Injectable } from "@angular/core";
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, interval } from 'rxjs';
import { NotificacionBundle } from 'src/common/notificacionBundle';
import { Fichada } from 'src/common/fichada';
import { TicketsPendientes } from 'src/common/ticketsPendientes';
import { delayWhen } from 'rxjs/operators';

@Injectable()
export class RecursosHumanosService {

	private readonly FIND_ULTIMA_FICHADA: string = environment.backendUrl + "/recursos-humanos/ultima-fichada";
	private readonly FIND_TICKETS_PENDIENTES: string = environment.backendUrl + "/recursos-humanos/tickets-pendientes";
	private readonly ID_PERSONA_PARAM: string = "idPersona";

	constructor( private http: HttpClient ) {
	}

	findUltimaFichada( idPersona: number ): Observable<NotificacionBundle<Fichada>> {
		let params: HttpParams = new HttpParams().set( this.ID_PERSONA_PARAM, idPersona.toString() );
		return this.http.get<NotificacionBundle<Fichada>>( this.FIND_ULTIMA_FICHADA, { params } );
	}

	findTicketsPendientes( idPersona: number ): Observable<NotificacionBundle<TicketsPendientes>> {
		let params: HttpParams = new HttpParams().set( this.ID_PERSONA_PARAM, idPersona.toString() );
		return this.http.get<NotificacionBundle<TicketsPendientes>>( this.FIND_TICKETS_PENDIENTES, { params } );
	}

}
